import { render } from "./App.vue?vue&type=template&id=00c20b0e"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=00c20b0e&lang=less"
script.render = render

export default script